import React from 'react';
import { motion } from 'framer-motion';

interface InteractiveCardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  hoverEffect?: 'scale' | 'lift' | 'glow';
}

const hoverEffects = {
  scale: {
    whileHover: { scale: 1.03 },
    whileTap: { scale: 0.97 },
  },
  lift: {
    whileHover: { y: -5, boxShadow: '0 10px 20px rgba(0,0,0,0.1)' },
    whileTap: { y: -2 },
  },
  glow: {
    whileHover: { 
      boxShadow: '0 0 25px rgba(147, 51, 234, 0.3)',
      scale: 1.01
    },
    whileTap: { scale: 0.99 },
  },
};

const InteractiveCard: React.FC<InteractiveCardProps> = ({ 
  children, 
  className = '', 
  onClick,
  hoverEffect = 'scale'
}) => {
  return (
    <motion.div
      {...hoverEffects[hoverEffect]}
      className={`${className} transition-all duration-300 cursor-pointer`}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );
};

export default InteractiveCard;